export default "__VITE_ASSET__BAucWP1I__"